import type { AgentCard, PlannedAgent } from '../types';

/** Local calendar date as YYYY-MM-DD, used to decide whether a target launch is overdue. */
export const todayStr = (now: Date = new Date()): string =>
  `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

export const clampProgress = (value: number): number =>
  Number.isFinite(value) ? Math.max(0, Math.min(100, Math.trunc(value))) : 0;

/** Compact '→ MM-DD' launch marker; overdue once the date has passed with progress below 100. */
export const launchLabel = (
  plan: PlannedAgent,
  today: string = todayStr(),
): { text: string; overdue: boolean } | null => {
  if (!plan.targetDate) {
    return null;
  }
  return {
    text: `→ ${plan.targetDate.slice(5)}`,
    overdue: plan.targetDate < today && clampProgress(plan.progress) < 100,
  };
};

/** Renders an idea as a dashed dashboard card so it sorts, filters and drags like any agent. */
export const plannedToCard = (plan: PlannedAgent): AgentCard => ({
  id: plan.id,
  section: plan.section,
  name: plan.name,
  goal: plan.objective,
  goalParts: plan.objective ? [{ text: plan.objective, bold: false }] : [],
  sub: plan.note,
  dot: '',
  badge: { text: 'planned', className: 'b-idle' },
  sched: 'idea · not scheduled',
  tags: [],
  owner: plan.owner || 'Kuen',
  runs: 0,
  runsText: '–',
  runsLabel: `progress ${clampProgress(plan.progress)}%`,
  succText: 'planned',
  succTone: 'new',
  planned: true,
  plan,
  loop: null,
});
